import * as tslib_1 from "tslib";
import { Base } from "../base-component";
import "./form-item-business-caf-ntb.component.scss";
import * as $ from "jquery";
import "bootstrap-datepicker";
import { TooltipsService } from '../../services/tooltips.service';
var FormItemBusinessCafNtb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCafNtb, _super);
    function FormItemBusinessCafNtb(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.count = 1;
        _this.sbPrefSupplier = "";
        _this.dataChecks = true;
        _this.map = new Map();
        _this.iSstep1Completed = false;
        _this.iSstep2Completed = false;
        _this.iSstep3Completed = false;
        _this.errors = [];
        _this.emptyerrors = [];
        _this.files = [];
        _this.tempFiles = [];
        _this.formData = new FormData();
        _this.selectTagOpen = false;
        _this.selectedExtras = [];
        _this.validFile = true;
        return _this;
    }
    FormItemBusinessCafNtb.prototype.init = function () {
        TooltipsService.initTooltips();
        this.form = this.element.querySelector("form");
        this.baseUrl = this.baseUrl || window.location.origin;
        this.businessType = this.element.querySelector(".js-business-type");
        this.loanPurpose = this.element.querySelector(".js-loan-purpose");
        this.loanAmount = this.element.querySelector(".js-loan-amount");
        this.wizardContainer = this.element.querySelector(".form-container-wizard__wizard");
        this.wizardStepsContainer = this.element.querySelector(".form-container-wizard__steps");
        this.bulletContainer = this.element.querySelector(".form-container-wizard__bullets-container");
        this.customHeading = this.element.querySelector(".customHeading");
        this.stepNo = this.element.querySelector(".form-container-wizard__stepno");
        this.sbAccountNumber = this.element.querySelector(".js-sb-account-number");
        this.formDatePicker = this.element.querySelector(".js-date-picker");
        this.formTimePicker = this.element.querySelector(".js-time-picker");
        this.puboffposAuthorityRb = Array.from(this.element.querySelectorAll(".js-pub-off-pos-auth-rg"));
        this.fileInvoice = this.element.querySelector('.clsInvoiceUpload');
        this.inputInvoice = this.element.querySelector('.js-input-invoice');
        this.balloonPercentage = this.element.querySelector(".js-balloon-percent");
        this.purPrice = this.element.querySelector("input[name=pur-price]");
        this.extrasDropdown = this.element.querySelector(".js-extras-select");
        this.divcheckboxdropdown = this.element.querySelector(".checkbox-dropdown");
        this.divcheckboxdropdownul = this.element.querySelector(".checkbox-dropdown ul");
        // buttons
        this.closeButton = this.element.querySelector(".js-apply-now-modal-close");
        this.backButton = Array.from(this.element.querySelectorAll(".js_prev-step-button"));
        this.selectBox = this.element.querySelector(".selectBox");
        this.step1Button = this.element.querySelector(".js_next-step1-button");
        this.step2Button = this.element.querySelector(".js_next-step2-button");
        this.step3Button = this.element.querySelector(".js_next-step3-button");
        //default step
        var _stepNo = this.element.querySelector("input[name=default-step]");
        this.showStep(_stepNo ? _stepNo.value : 1);
        this.depositRadiosToggle = Array.from(this.element.querySelectorAll(".js-deposit-rg"));
        this.extrasRadiosToggle = Array.from(this.element.querySelectorAll(".js-extras-rg"));
        this.totalExtrasAmount = this.element.querySelector("input[name=extras-amount]");
        this.licenseFees = this.element.querySelector("input[name=license-reg-extras]");
        this.otherExtras = this.element.querySelector("input[name=other-extras]");
        this.deposit = this.element.querySelector("input[name=dep-amount]");
        this.totalLoanAmount = this.element.querySelector("input[name=total-loan-amount]");
        this.assetYear = this.element.querySelector(".js-asset-year");
        this.assetMake = this.element.querySelector(".js-asset-make");
        this.assetModel = this.element.querySelector(".js-asset-model");
        this.assetExtras = this.element.querySelector(".js-asset-extras");
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector(".form-container__error");
            this.displayDecline = this.form.querySelector(".form-container__declined");
        }
        this.buttonSubmit = this.element.querySelector(".js_submit-button");
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector(".data-privacy-collapse-show");
        this.showLessBtn = this.element.querySelector(".data-privacy-collapse-hide");
        this.dataPrivacyDetailArea = this.element.querySelector(".data-privacy-detail");
        this.dataSharingGroupHideBtn = this.element.querySelector(".data-sharing-group-hide-btn");
        this.dataSharingGroupShowBtn = this.element.querySelector(".data-sharing-group-show-btn");
        this.dataSharingGroupTextArea = this.element.querySelector(".data-sharing-group");
        this.dataSharing3rdPartyShowBtn = this.element.querySelector(".data-sharing-3rd-party-show-btn");
        this.dataSharing3rdPartyHideBtn = this.element.querySelector(".data-sharing-3rd-party-hide-btn");
        this.dataSharing3rdPartyTextArea = this.element.querySelector(".data-sharing-3rd-party");
        this.dataSharingBoardersHideBtn = this.element.querySelector(".data-sharing-boarders-hide-btn");
        this.dataSharingBoardersShowBtn = this.element.querySelector(".data-sharing-boarders-show-btn");
        this.dataSharingBoardersTextArea = this.element.querySelector(".data-sharing-boarders");
        this.dataSharingTeleSaleHideBtn = this.element.querySelector(".data-sharing-telesale-hide-btn");
        this.dataSharingTeleSaleShowBtn = this.element.querySelector(".data-sharing-telesale-show-btn");
        this.dataSharingTeleSaleTextArea = this.element.querySelector(".data-sharing-telesale");
        this.dataSharingSmsShowBtn = this.element.querySelector(".data-sharing-email-show-btn");
        this.dataSharingSmsHideBtn = this.element.querySelector(".data-sharing-email-hide-btn");
        this.dataSharingSmsTextArea = this.element.querySelector(".data-sharing-email");
        this.dataSharingEmailHideBtn = this.element.querySelector(".data-sharing-sms-hide-btn");
        this.dataSharingEmailShowBtn = this.element.querySelector(".data-sharing-sms-show-btn");
        this.dataSharingEmailTextArea =
            this.element.querySelector(".data-sharing-sms");
        this.relPartiesHideBtn = this.element.querySelector(".data-rel-parties-hide-btn");
        this.relPartiesShowBtn = this.element.querySelector(".data-rel-parties-show-btn");
        this.relPartiesContent = this.element.querySelector(".data-rel-parties-content");
        //Analytics
        this.form.setAttribute("data-frmcontainer", "business commercial asset finance | personal details");
        this.analyticsService.startDtmApplication("application: borrow for your needs | vehicle finance", "commercial asset finance");
        this.updatePageName("step 1 personal details form");
    };
    FormItemBusinessCafNtb.prototype.bindEvents = function () {
        var _this = this;
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input:not([type=file]):not(.js-input-invoice), select"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        //Upload
        this.fileInvoice.addEventListener("change", function (event) {
            var selectedFile = event.target.files;
            if (selectedFile) {
                if (selectedFile.length > 0) {
                    _this.inputInvoice.value = selectedFile[0].name;
                    var field = event.target;
                    _this.removeErrorMessage(field);
                    _this.files = [];
                    _this.removeErrorMessage(field);
                    if (_this.validationCheck(selectedFile[0], field)) {
                        _this.createFilesArray(selectedFile[0], 'invoice');
                    }
                }
            }
        });
        this.inputInvoice.addEventListener('click', function () {
            _this.fileInvoice.click();
        });
        this.puboffposAuthorityRb.map(function (item) {
            return item.addEventListener("click", function (event) {
                var element = event.target;
                _this.toggleModifiersExt(event, ".js-puboff-authority-container", "YES");
            });
        });
        if (this.assetYear) {
            this.assetYear.addEventListener("change", function (event) {
                _this.getVehicleMake(_this.assetYear.value);
            });
        }
        if (this.assetMake) {
            this.assetMake.addEventListener("change", function (event) {
                _this.getVehicleModel(_this.assetYear.value, _this.assetMake.value);
            });
        }
        if (this.assetModel) {
            this.assetModel.addEventListener("change", function (event) {
                _this.getVehicleExtras(_this.assetModel.value, _this.assetYear.value);
            });
        }
        //Calender
        if (this.formDatePicker) {
            this.formDatePicker.addEventListener("change", function (event) {
                _this.validateDate(event.target);
            });
        }
        //#region Next,Back,close and done buttons
        //Step 1 Next Button
        if (this.step1Button) {
            this.step1Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step1");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep1Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep1Completed = true;
                    _this.dtmVirtualPage("step 2 business details form");
                    _this.showStep(2);
                }
            });
        }
        //Step 2 Next Button
        if (this.step2Button) {
            this.step2Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step2");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                var _authorityToApply = _form.querySelector("input[name=permission-act]:checked");
                var _legallyEnterContracts = _form.querySelector("input[name=legal-contracts]:checked");
                var _existingBounceBackLoan = _form.querySelector("input[name=covid19-loan]:checked");
                var _debtReview = _form.querySelector("input[name=debt-review]:checked");
                var _declineReasons = _this.element.querySelector(".js-decline-reasons-list");
                _this.map.clear();
                _this.dataChecks = true;
                if (valid.length === 0) {
                    if (_authorityToApply && _authorityToApply.value === "NO") {
                        _this.dataChecks = false;
                        _this.map.set("Authority", "Permission to act on behalf of the entity");
                    }
                    if (_legallyEnterContracts && _legallyEnterContracts.value === "NO") {
                        _this.dataChecks = false;
                        _this.map.set("Legal", "Legally enter into contracts");
                    }
                    if (_existingBounceBackLoan && _existingBounceBackLoan.value === 'YES') {
                        _this.dataChecks = false;
                        _this.map.set('ExistingLoan', 'Covid 19 loan with Standard bank or any other institute');
                    }
                    if (_debtReview && _debtReview.value === "YES") {
                        _this.dataChecks = false;
                        _this.map.set("DebtReview", "Debt review");
                    }
                    _declineReasons.innerHTML = "";
                    _this.map.forEach(function (value, key) {
                        var li = document.createElement("li");
                        li.innerHTML = value;
                        _declineReasons.appendChild(li);
                    });
                    if (!_this.dataChecks) {
                        _this.showDisplayView("decline");
                        window.scrollTo(0, 0);
                    }
                    else {
                        _this.count += 1;
                        if (!_this.iSstep2Completed && !dataLayer.formisSubmitted)
                            _this.analyticsService.dtmFormComplete("complete", "", true);
                        _this.iSstep2Completed = true;
                        _this.dtmVirtualPage("step 3 loan details form");
                        _this.showStep(3);
                    }
                }
            });
        }
        //Step 3 Next Button Click
        if (this.step3Button) {
            this.step3Button.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step3");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.count += 1;
                    if (!_this.iSstep3Completed && !dataLayer.formisSubmitted)
                        _this.analyticsService.dtmFormComplete("complete", "", true);
                    _this.iSstep3Completed = true;
                    _this.dtmVirtualPage("step 4 account details form");
                    _this.showStep(4);
                    //Bind years dropdown
                    _this.getVehicleYears();
                }
            });
        }
        //Step 4 Submit Button Click
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _form = _this.form.querySelector(".step4");
                var formFields = _form.querySelectorAll("input:not([type=file]):not(.js-input-invoice), select");
                _this.validationService.validate(formFields);
                var _totalLoanAmount = _form.querySelector("input[name=total-loan-amount]");
                if (_totalLoanAmount.value === "0") {
                    var form_group = _totalLoanAmount.closest('.form__group');
                    form_group.classList.add('form__group--error');
                    _this.validationService.addErrorMessage(_totalLoanAmount, ["Invalid total loan amount"]);
                }
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_this.form);
                }
            });
        }
        //Back button
        if (this.backButton.length) {
            this.backButton.map(function (item) {
                return item.addEventListener("click", function (event) {
                    _this.showPreviousStep(event);
                });
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener("click", function (event) {
                return _this.closeForm("done");
            });
        }
        if (this.closeButton) {
            this.closeButton.addEventListener("click", function (event) {
                return _this.closeForm("close");
            });
        }
        //#endregion
        if (this.businessType) {
            this.businessType.addEventListener("change", function () {
                return _this.validateBusinessType("validate");
            });
        }
        //Balloon amount
        if (this.balloonPercentage) {
            this.balloonPercentage.addEventListener("change", function () {
                _this.calculateBalloon();
            });
        }
        //Total loan amount
        if (this.purPrice) {
            this.purPrice.addEventListener("blur", function () {
                _this.calculateTotalLoan();
            });
        }
        if (this.totalExtrasAmount) {
            this.totalExtrasAmount.addEventListener("blur", function () {
                _this.calculateTotalLoan();
            });
        }
        if (this.licenseFees) {
            this.licenseFees.addEventListener("blur", function () {
                _this.calculateTotalLoan();
            });
        }
        if (this.otherExtras) {
            this.otherExtras.addEventListener("blur", function () {
                _this.calculateTotalLoan();
            });
        }
        if (this.deposit) {
            this.deposit.addEventListener("blur", function () {
                _this.calculateTotalLoan();
            });
        }
        this.extrasRadiosToggle.map(function (item) {
            return item.addEventListener("click", function (event) {
                var element = event.target;
                _this.toggleModifiers(event, ".js-extras-container", false);
                var _totalExtrasAmount = _this.form.querySelector("input[name=extras-amount]");
                var _licenseFees = _this.form.querySelector("input[name=license-reg-extras]");
                var _otherExtras = _this.form.querySelector("input[name=other-extras]");
                if (element.value == "NO" && _totalExtrasAmount && _licenseFees && _otherExtras) {
                    _totalExtrasAmount.value = '0';
                    _licenseFees.value = '0';
                    _otherExtras.value = '0';
                }
                _this.calculateTotalLoan();
            });
        });
        this.depositRadiosToggle.map(function (item) {
            return item.addEventListener("click", function (event) {
                var element = event.target;
                _this.toggleModifiers(event, ".js-deposit-container", false);
                var _depositAmount = _this.form.querySelector("input[name=dep-amount]");
                if (element.value == "NO" && _depositAmount) {
                    _depositAmount.value = '0';
                }
                _this.calculateTotalLoan();
            });
        });
        document.addEventListener('click', function (event) {
            var target = event.target;
            if (!target.matches('.checkbox-dropdown')) {
                var dropdown = document.querySelector(".checkbox-dropdown");
                if (dropdown.classList.contains('is-active')) {
                    dropdown.classList.remove('is-active');
                }
            }
        });
        this.divcheckboxdropdown.addEventListener("click", function (event) {
            var element = event.target;
            if (!_this.selectTagOpen) {
                _this.selectTagOpen = true;
                element.classList.add("is-active");
            }
            else {
                _this.selectTagOpen = false;
                element.classList.remove("is-active");
            }
        });
        this.divcheckboxdropdownul.addEventListener("click", function (event) {
            event.stopPropagation();
        });
        //#region consents
        this.showLessBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute("hidden", "true");
            _this.showMoreBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.setAttribute("hidden", "true");
        });
        this.showMoreBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute("hidden", "true");
            _this.showLessBtn.removeAttribute("hidden");
            _this.dataPrivacyDetailArea.removeAttribute("hidden");
        });
        this.dataSharingGroupHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute("hidden", "true");
            _this.dataSharingGroupHideBtn.setAttribute("hidden", "true");
            _this.dataSharingGroupShowBtn.removeAttribute("hidden");
        });
        this.dataSharingGroupShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute("hidden");
            _this.dataSharingGroupHideBtn.removeAttribute("hidden");
            _this.dataSharingGroupShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute("hidden", "true");
            _this.dataSharing3rdPartyShowBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.setAttribute("hidden", "true");
        });
        this.dataSharing3rdPartyShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute("hidden");
            _this.dataSharing3rdPartyHideBtn.removeAttribute("hidden");
            _this.dataSharing3rdPartyShowBtn.setAttribute("hidden", "true");
        });
        this.dataSharingBoardersShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute("hidden");
            _this.dataSharingBoardersShowBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.removeAttribute("hidden");
        });
        this.dataSharingBoardersHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute("hidden", "true");
            _this.dataSharingBoardersHideBtn.setAttribute("hidden", "true");
            _this.dataSharingBoardersShowBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute("hidden");
            _this.dataSharingTeleSaleShowBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.removeAttribute("hidden");
        });
        this.dataSharingTeleSaleHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleHideBtn.setAttribute("hidden", "true");
            _this.dataSharingTeleSaleShowBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute("hidden");
            _this.dataSharingSmsShowBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.removeAttribute("hidden");
        });
        this.dataSharingSmsHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute("hidden", "true");
            _this.dataSharingSmsHideBtn.setAttribute("hidden", "true");
            _this.dataSharingSmsShowBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute("hidden");
            _this.dataSharingEmailShowBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.removeAttribute("hidden");
        });
        this.dataSharingEmailHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute("hidden", "true");
            _this.dataSharingEmailHideBtn.setAttribute("hidden", "true");
            _this.dataSharingEmailShowBtn.removeAttribute("hidden");
        });
        this.relPartiesShowBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.relPartiesContent.removeAttribute("hidden");
            _this.relPartiesShowBtn.setAttribute("hidden", "true");
            _this.relPartiesHideBtn.removeAttribute("hidden");
        });
        this.relPartiesHideBtn.addEventListener("click", function (e) {
            e.preventDefault();
            _this.relPartiesContent.setAttribute("hidden", "true");
            _this.relPartiesHideBtn.setAttribute("hidden", "true");
            _this.relPartiesShowBtn.removeAttribute("hidden");
        });
        //#endregion
    };
    FormItemBusinessCafNtb.prototype.calculateTotalLoan = function () {
        var _purPrice = this.form.querySelector("input[name=pur-price]");
        var _totalExtrasAmount = this.form.querySelector("input[name=extras-amount]");
        var _licenseFees = this.form.querySelector("input[name=license-reg-extras]");
        var _otherExtras = this.form.querySelector("input[name=other-extras]");
        var _deposit = this.form.querySelector("input[name=dep-amount]");
        var _totalLoanAmount = this.form.querySelector("input[name=total-loan-amount]");
        var _vpurPrice = (_purPrice && _purPrice.value != "") ? _purPrice.value : 0;
        var _vtotalExtrasAmount = (_totalExtrasAmount && _totalExtrasAmount.value != "") ? _totalExtrasAmount.value : 0;
        var _vlicenseFees = (_licenseFees && _licenseFees.value != "") ? _licenseFees.value : 0;
        var _votherExtras = (_otherExtras && _otherExtras.value != "") ? _otherExtras.value : 0;
        var _vdeposit = (_deposit && _deposit.value != "") ? _deposit.value : 0;
        var total = parseFloat(_vpurPrice) + parseFloat(_vtotalExtrasAmount) + parseFloat(_vlicenseFees) + parseFloat(_votherExtras) - parseFloat(_vdeposit);
        _totalLoanAmount.value = total;
        if (_totalLoanAmount.value === "0" && _totalLoanAmount.value === "-1") {
            var form_group = _totalLoanAmount.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.validationService.addErrorMessage(_totalLoanAmount, ["Invalid total loan amount"]);
        }
        this.calculateBalloon();
    };
    FormItemBusinessCafNtb.prototype.calculateBalloon = function () {
        var _balloonPercentage = this.form.querySelector("select[name=balloon-percent]");
        var _totalLoanAmount = this.form.querySelector("input[name=total-loan-amount]");
        var _balloonAmount = this.form.querySelector("input[name=balloon-amount]");
        if (_balloonPercentage.value !== "" || _totalLoanAmount.value !== "") {
            var balloon = (_balloonPercentage.value * _totalLoanAmount.value) / 100;
            _balloonAmount.value = balloon;
        }
    };
    FormItemBusinessCafNtb.prototype.getSelectedExtras = function () {
        var _this = this;
        var checkboxes = this.element.querySelectorAll('.checkbox-dropdown-list input[type="checkbox"]');
        checkboxes.forEach(function (checkbox) {
            if (checkbox.checked) {
                _this.selectedExtras.push(checkbox.value);
            }
        });
    };
    FormItemBusinessCafNtb.prototype.addErrorMessage = function (pElement, pMessages) {
        var _parent = pElement.closest(".form__group");
        if (_parent) {
            var _errorDiv = _parent.querySelector(".form__group--error_message");
            if (_errorDiv) {
                _errorDiv.remove();
            }
            if (pMessages.length > 0) {
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors_1 = document.createElement("ul");
                pMessages.forEach(function (pMessage) {
                    var _error = document.createElement("li");
                    _error.innerHTML = pMessage;
                    _errors_1.appendChild(_error);
                });
                _errorDiv.appendChild(_errors_1);
                if (_parent) {
                    _parent.appendChild(_errorDiv);
                }
            }
        }
    };
    FormItemBusinessCafNtb.prototype.removeItemsWithName = function (name) {
        var _this = this;
        var _loop_1 = function (i) {
            this_1.files.forEach(function (item, index) {
                if (item.name.split('_', 2)[0] === name[i])
                    _this.files.splice(index, 1);
            });
        };
        var this_1 = this;
        for (var i = 0; i < name.length; i++) {
            _loop_1(i);
        }
    };
    FormItemBusinessCafNtb.prototype.createFilesArray = function (file, key) {
        this.removeItemsWithName([key]);
        var fname = key + '_' + file.name;
        this.files.push({ data: file, name: fname });
    };
    FormItemBusinessCafNtb.prototype.createFileFormData = function () {
        for (var i = 0; i < this.files.length; i++) {
            var newFileName = this.files[i].name;
            this.formData.append('file', this.files[i].data, newFileName);
        }
    };
    FormItemBusinessCafNtb.prototype.closeForm = function (type) {
        if (type === "close") {
            this.analyticsService.dtmFormAbandon();
            window.location.href = this.closeButton.getAttribute('data-url');
        }
        else {
            window.location.href = this.doneSubmit.getAttribute('data-url');
        }
        this.form.reset();
    };
    FormItemBusinessCafNtb.prototype.updateForm = function (pType) {
        if (this.sbAccountNumber) {
            var _group = this.sbAccountNumber.closest(".form__group");
            if (pType !== "YES") {
                this.sbAccountNumber.classList.remove("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
            else {
                this.sbAccountNumber.classList.remove("form__input--required");
                _group.classList.remove("form__group--hidden");
            }
        }
    };
    FormItemBusinessCafNtb.prototype.validate = function (fields) {
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            if (field.type != 'hidden') {
                this.validateEmptyTrustOtherEntity(field);
            }
        }
    };
    FormItemBusinessCafNtb.prototype.validateEmptyTrustOtherEntity = function (fieldBusReg) {
        this.emptyerrors = [];
        var format = /[-`~!@#$%^&*()_+=\[\]{};:"\\|,<>?]/;
        if (fieldBusReg) {
            if (fieldBusReg.value.length === 0) {
                this.emptyerrors.push("This field is required");
                var form_group = $(fieldBusReg).closest(".form__group");
                form_group.addClass("form__group--error");
                this.addErrorMessage(fieldBusReg, this.emptyerrors);
            }
            else {
                if (fieldBusReg.name === 'business-reg-number-trust') {
                    if (fieldBusReg.value.length == 2) {
                        this.emptyerrors.push('Please enter a valid trust eg. IT1234/1234');
                        var form_group = $(fieldBusReg).closest(".form__group");
                        form_group.addClass("form__group--error");
                        this.addErrorMessage(fieldBusReg, this.emptyerrors);
                    }
                    else if (fieldBusReg.value.length > 2 && fieldBusReg.value.substring(0, 2).toUpperCase() !== 'IT') {
                        this.emptyerrors.push('Please enter a valid trust reg. number starting with IT');
                        var form_group = $(fieldBusReg).closest(".form__group");
                        form_group.addClass("form__group--error");
                        this.addErrorMessage(fieldBusReg, this.emptyerrors);
                    }
                }
                else if (format.test(fieldBusReg.value)) {
                    this.emptyerrors.push('Please remove special characters');
                    var form_group = $(fieldBusReg).closest(".form__group");
                    form_group.addClass("form__group--error");
                    this.addErrorMessage(fieldBusReg, this.emptyerrors);
                }
            }
            if (this.emptyerrors.length == 0) {
                var _parent = fieldBusReg.closest(".form__group");
                if (_parent) {
                    fieldBusReg.closest(".form__group").classList.remove("form__group--error");
                    var _errorDiv = _parent.querySelector(".form__group--error_message");
                    if (_errorDiv) {
                        _errorDiv.remove();
                    }
                }
            }
        }
    };
    FormItemBusinessCafNtb.prototype.validateBusinessType = function (type) {
        var _this = this;
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = _stringLength - 1;
            var _check = event.substring(_newLength);
            var reg = new RegExp("^[0-9]+$");
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += "/";
                }
                else if (event.length === 11) {
                    event = event += "/";
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split("/");
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp("^/d{4}$");
                    var _seg2 = new RegExp("^/d{6}$");
                    var _seg3 = new RegExp("^/d{2}$");
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return "";
                    }
                }
                else {
                    return "";
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return (_firstcharacters +
                    "/" +
                    _secondCharacters +
                    "/" +
                    _thirdCharacters);
            }
            return "";
        }
        function deleteContent(event) {
            if (event.inputType !== "deleteContentBackward" &&
                event.inputType !== "deleteContentForward") {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
        if (this.businessType.value === "PRIVATE" ||
            this.businessType.value === "CLOSE" ||
            this.businessType.value === "PUBLIC" ||
            this.businessType.value === "OTHER" ||
            this.businessType.value === "TRUST") {
            var fieldIdno = this.form.querySelector('input[name="id-number"]');
            var fieldBusReg = this.form.querySelector('input[name="business-reg-number"]');
            var field = void 0;
            if (fieldBusReg) {
                field = fieldBusReg;
            }
            else if (fieldIdno) {
                field = fieldIdno;
            }
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var errorMessage = formGroupItem.querySelector('.form__group--error_message');
                if (errorMessage) {
                    errorMessage.remove();
                }
                var labelItem = formGroupItem.querySelector("label");
                labelItem.innerText = "Business Registration Number";
                var newBusRegField = document.createElement("input");
                newBusRegField.setAttribute("name", "business-reg-number");
                newBusRegField.classList.remove("form__input--required");
                newBusRegField.classList.remove("form__input--busReg");
                newBusRegField.classList.remove("form__input--business-registration");
                newBusRegField.classList.add("form__input");
                newBusRegField.placeholder = "Enter your business registration number";
                if (this.businessType.value === "OtherContent") {
                    labelItem.innerText = "Registration Number";
                    newBusRegField.setAttribute("name", "business-reg-number-other");
                    newBusRegField.setAttribute("id", "business-reg-number-other");
                    newBusRegField.classList.add("form__input");
                    newBusRegField.classList.add("solarloan_busreg_other_input");
                    newBusRegField.placeholder = "Enter your registration number";
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validateEmptyTrustOtherEntity(pEvent.currentTarget);
                    });
                }
                else if (this.businessType.value === "Trust") {
                    labelItem.innerText = "Trust Registration Number";
                    newBusRegField.value = "IT";
                    newBusRegField.setAttribute("name", "business-reg-number-trust");
                    newBusRegField.setAttribute("id", "business-reg-number-trust");
                    newBusRegField.classList.add("form__input");
                    newBusRegField.classList.add("solarloan_busreg_trust_input");
                    newBusRegField.placeholder = "Enter your trust registration number";
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validateEmptyTrustOtherEntity(pEvent.currentTarget);
                    });
                }
                else {
                    newBusRegField.classList.add("form__input--required");
                    newBusRegField.classList.add("form__input--busReg");
                    newBusRegField.classList.add("form__input--business-registration");
                    // This adds slashes to the business registration number
                    newBusRegField.addEventListener("input", deleteContent);
                    newBusRegField.addEventListener("blur", addBlur);
                    newBusRegField.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                }
                field.parentNode.replaceChild(newBusRegField, field);
            }
        }
        else if (this.businessType.value === "PARTNER" || this.businessType.value === "SOLE") {
            // This removes event listener
            var fieldBusReg = this.form.querySelector('input[name="business-reg-number"]');
            var fieldIdno = this.form.querySelector('input[name="id-number"]');
            //const fieldBusRegTrust: any = this.form.querySelector('input[name="business-reg-number-trust"]');
            //const fieldBusRegOther: any = this.form.querySelector('input[name="business-reg-number-other"]');
            var field = void 0;
            if (fieldBusReg) {
                field = fieldBusReg;
            }
            else if (fieldIdno) {
                field = fieldIdno;
            }
            // } else if (fieldBusRegTrust) {
            // 	field = fieldBusRegTrust;
            // } else if (fieldBusRegOther) {
            // 	field = fieldBusRegOther;
            // }
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var errorMessage = formGroupItem.querySelector('.form__group--error_message');
                if (errorMessage) {
                    errorMessage.remove();
                }
                var labelItem = formGroupItem.querySelector("label");
                labelItem.innerText = "ID Number";
                var newIdField = document.createElement("input");
                newIdField.setAttribute("name", "id-number");
                newIdField.setAttribute("maxlength", "13");
                newIdField.classList.add("form__input");
                newIdField.classList.add("form__input--required");
                newIdField.classList.add("form__input--identification");
                if (this.businessType.value === "PARTNER") {
                    newIdField.classList.remove("form__input--required");
                    newIdField.classList.remove("form__input--identification");
                }
                newIdField.placeholder = "Enter your South African ID number";
                newIdField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newIdField, field);
            }
        }
        else {
            //((this.businessType.value === `OtherContent`) || (this.businessType.value === `Trusts`)){
        }
    };
    FormItemBusinessCafNtb.prototype.removeErrorMessage = function (field) {
        var formGroup = field.closest('.form__group');
        if (formGroup) {
            field.closest('.form__group').classList.remove('form__group--error');
            var errorMessage = field.closest('.form__group').querySelector(".form__group--error_message");
            if (errorMessage) {
                errorMessage.remove();
            }
        }
    };
    FormItemBusinessCafNtb.prototype.validationCheck = function (file, field) {
        this.errors = [];
        var valid = true;
        var max_size = 3145728; //4194304;
        var allowed_types = ['image/png', 'image/jpeg', 'application/pdf'];
        var pattern = /[/]/;
        var regEx = new RegExp('^[a-zA-Z0-9\\s_.,]+$'); //RegExp('^[a-zA-Z0-9\\s/!@#$%^&*()]+$');
        var res = file.name.substr(0, file.name.lastIndexOf('.')); //file.name.substr(file.name.lastIndexOf('.')+1, file.name.length); 
        if (file.name.length > 53) {
            this.errors.push('File name is too long');
            valid = false;
        }
        else if (!regEx.test(res)) {
            this.errors.push('File name with special characters are not allowed');
            valid = false;
        }
        else if (file.size > max_size) {
            this.errors.push('Maximum size allowed is 3Mb');
            valid = false;
        }
        else if (!_.includes(allowed_types, file.type)) {
            this.errors.push('Please upload your documents in a PDF, JPG or PNG format'); //Please try again using the supported file formats.
            valid = false;
        }
        else if (this.checkFileExist(file.name)) {
            this.errors.push('File with same name already exists');
            valid = false;
        }
        if (!valid) {
            var form_group = field.closest('.form__group');
            form_group.classList.add('form__group--error');
            this.validationService.addErrorMessage(field, this.errors);
        }
        return valid;
    };
    FormItemBusinessCafNtb.prototype.checkFileExist = function (fileName) {
        return this.files.filter(function (f) { return f.data.name === fileName; }).length > 1;
    };
    FormItemBusinessCafNtb.prototype.showStep = function (stepId) {
        var showStep = parseFloat(stepId);
        if (this.bulletContainer) {
            var _bullets = Array.from(this.bulletContainer.querySelectorAll(".form-container-wizard__bullets-container--bullet"));
            _bullets.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (displayStep <= showStep) {
                    pItem.classList.add("form-container-wizard__bullets-container--bullet--active");
                }
                else {
                    pItem.classList.remove("form-container-wizard__bullets-container--bullet--active");
                }
            });
            var _bulletLines = Array.from(this.bulletContainer.querySelectorAll(".form-item-business-caf-ntb__form-container-wizard__bullets-container--bullet--link"));
            _bulletLines.map(function (pItem) {
                var displayStep = parseFloat(pItem.getAttribute("data-step"));
                if (showStep > displayStep) {
                    pItem.classList.add("form-item-business-caf-ntb__form-container-wizard__bullets-container--bullet--link--active");
                }
                else {
                    pItem.classList.remove("form-item-business-caf-ntb__form-container-wizard__bullets-container--bullet--link--active");
                }
            });
        }
        var _steps = Array.from(this.wizardStepsContainer.querySelectorAll(".form-container-wizard__steps--step"));
        var _heading = "";
        _steps.map(function (pStep) {
            var _step = parseFloat(pStep.getAttribute("data-step"));
            if (_step == showStep) {
                _heading = pStep.getAttribute("data-heading");
                pStep.classList.remove("form-container-wizard__steps--hidden");
            }
            else {
                pStep.classList.add("form-container-wizard__steps--hidden");
            }
        });
        var _h3Heading = this.customHeading.querySelector("h3");
        if (_heading != null) {
            _h3Heading.innerHTML = _heading;
        }
        var _stepno = this.stepNo.querySelector("h6");
        if (_stepno != null) {
            _stepno.innerHTML = "STEP " + showStep + " OF 3";
        }
        window.scrollTo(0, 0);
    };
    FormItemBusinessCafNtb.prototype.showNextStep = function (event) {
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
    };
    FormItemBusinessCafNtb.prototype.showPreviousStep = function (event) {
        this.showDisplayView("");
        var _target = event.currentTarget;
        var _currentStep = _target.closest("[data-step]");
        var _nextStep = _currentStep.getAttribute("data-step");
        this.showStep(parseFloat(_nextStep));
        window.scrollTo(0, 0);
    };
    FormItemBusinessCafNtb.prototype.getVehicleYears = function () {
        var _url = this.baseUrl + '/bcbsadocumentupload/vaf/years-list';
        var _select = this.form.querySelector("select[name=asset-year]");
        //this.showDisplayView(`loader`);
        if (_select) {
            this.http.get(_url).then(function (response) {
                if (response.data.length > 0) {
                    var vehicleyears = response.data;
                    for (var i = 0; i < vehicleyears.length; i++) {
                        var opt = document.createElement('option');
                        opt.value = vehicleyears[i];
                        opt.innerHTML = vehicleyears[i];
                        _select.appendChild(opt);
                    }
                }
            });
            // .catch((pError) => {
            // 	this.analyticsService.dtmRecordSiteError(`noerrorcode|service failure occured|` + _url);
            // });
        }
    };
    FormItemBusinessCafNtb.prototype.getVehicleMake = function (regyear) {
        var _url = this.baseUrl + '/bcbsadocumentupload/vaf/detail-by-reg-year/' + regyear;
        var _select = this.form.querySelector("select[name=asset-make]");
        //this.showDisplayView(`loader`);
        this.removeOpt(_select);
        if (_select) {
            this.http.get(_url)
                .then(function (response) {
                if (response.data.length > 0) {
                    var vehiclemake = response.data;
                    for (var i = 0; i < vehiclemake.length; i++) {
                        var opt = document.createElement('option');
                        opt.value = vehiclemake[i].make;
                        opt.innerHTML = vehiclemake[i].make;
                        _select.appendChild(opt);
                    }
                }
            });
            // .catch((pError) => {
            // 	this.analyticsService.dtmRecordSiteError(`noerrorcode|service failure occured|` + _url);
            // });
        }
    };
    FormItemBusinessCafNtb.prototype.getVehicleModel = function (regyear, make) {
        var _url = this.baseUrl + '/bcbsadocumentupload/vaf/detail-by-make/' + make + '/' + regyear;
        var _select = this.form.querySelector("select[name=asset-model]");
        //this.showDisplayView(`loader`);
        this.removeOpt(_select);
        if (_select) {
            this.http.get(_url)
                .then(function (response) {
                if (response.data.length > 0) {
                    var vehiclemodel = response.data;
                    for (var i = 0; i < vehiclemodel.length; i++) {
                        var opt = document.createElement('option');
                        opt.value = vehiclemodel[i].mmCode;
                        opt.innerHTML = vehiclemodel[i].variant;
                        _select.appendChild(opt);
                    }
                }
            });
            // .catch((pError) => {
            // 	this.analyticsService.dtmRecordSiteError(`noerrorcode|service failure occured|` + _url);
            // });
        }
    };
    FormItemBusinessCafNtb.prototype.getVehicleExtras = function (mmcode, year) {
        var _this = this;
        var _url = this.baseUrl + '/bcbsadocumentupload/vaf/vehicle-extras/' + mmcode + '/' + year;
        var divExtrasListContainer = this.element.querySelector(".checkbox-dropdown-list");
        var divExtras = this.element.querySelector(".checkbox-dropdown label");
        divExtrasListContainer.innerHTML = null;
        this.http.get(_url)
            .then(function (response) {
            if (response.data.length > 0) {
                var vehicleextras = response.data;
                for (var i = 0; i < vehicleextras.length; i++) {
                    var element2 = document.createElement("input");
                    element2.type = "checkbox";
                    element2.id = "chk_" + i;
                    element2.value = vehicleextras[i]['option_Code'];
                    element2.addEventListener('change', function (e) {
                        var element = e.target;
                        if (element.checked === true) {
                            _this.selectedExtras.push({ id: i, value: element.value });
                        }
                        else {
                            var index = _this.selectedExtras.findIndex(function (item) { return item.id === i; });
                            _this.selectedExtras.splice(index, 1);
                        }
                        if (_this.selectedExtras.length > 0) {
                            divExtras.innerHTML = "";
                            divExtras.innerHTML = _this.selectedExtras.length + ' extra(s) selected';
                        }
                        else {
                            divExtras.innerHTML = "";
                            divExtras.innerHTML = "Please select";
                        }
                    });
                    var label = document.createElement("label");
                    label.htmlFor = "chk_" + i;
                    label.appendChild(element2);
                    label.appendChild(document.createTextNode(vehicleextras[i]['option_Name']));
                    divExtrasListContainer.appendChild(label);
                    var li = document.createElement("li");
                    li.appendChild(label);
                    divExtrasListContainer.appendChild(li);
                }
            }
            else {
                var label = document.createElement("label");
                label.appendChild(document.createTextNode("No extras found"));
                var li = document.createElement("li");
                li.appendChild(label);
                divExtrasListContainer.appendChild(li);
            }
        });
    };
    FormItemBusinessCafNtb.prototype.removeOpt = function (selector) {
        var length = selector.options.length;
        if (length > 0) {
            for (var i = length - 1; i > 0; i--) {
                selector.remove(i);
            }
        }
    };
    FormItemBusinessCafNtb.prototype.submitForm = function (form) {
        var _this = this;
        var _email = form.querySelector("input[name=email]");
        var _recipient = form.querySelector("input[name=recipient]");
        var _subject = form.querySelector("input[name=subject]");
        var _firstName = form.querySelector("input[name=first-name]");
        var _surname = form.querySelector("input[name=surname]");
        var _emailAddress = form.querySelector("input[name=email-address]");
        var _phoneNumber = form.querySelector("input[name=contact-number]");
        var _identificationNo = form.querySelector("input[name=identity-number]");
        var _businessRelation = form.querySelector("input[name=business-relation]");
        var _pubofficial = form.querySelector("input[name=rb-pub-official]"); //radio
        var _relpubofficial = form.querySelector("input[name=rb-rel-pub-official]"); //radio
        var _nameOfIndividual = form.querySelector("input[name=pub-official-name]");
        var _natureOfRelation = form.querySelector("input[name=pub-official-relationship]");
        var _dataPrivacyConsent = form.querySelector("input[name=privacy-consent]");
        var _businessName = form.querySelector("input[name=business-name]");
        var _entityType = form.querySelector("select[name=business-type]");
        var _businessIndustry = form.querySelector("select[name=business-industry]");
        var _businessNature = form.querySelector("select[name=business-nature]");
        //const _businessDescription: any = form.querySelector(`input[name=business-description]`);
        var _businessRegion = form.querySelector("select[name=business-region]");
        var _yearsOperating = form.querySelector("input[name=business-trade-years]");
        var _businessEmailAddress = form.querySelector("input[name=business-email-address]");
        var _permissionToActOnBehalf = form.querySelector("input[name=permission-act]"); //radio		
        var _legallyEnterContracts = form.querySelector("input[name=legal-contracts]"); //radio
        var _covid19Loan = form.querySelector("input[name=covid19-loan]"); //radio
        var _debtReview = form.querySelector("input[name=debt-review]"); //radio		
        var _businessRegNumber = form.querySelector("input[name=business-reg-number]");
        //const _businessOtherNumber: any = form.querySelector(`input[name=business-reg-number-other]`);
        //const _businessTrustNumber: any = form.querySelector(`input[name=business-reg-number-trust]`);
        var _businessId = form.querySelector("input[name=id-number]");
        var _vehicleCondition = form.querySelector("input[name=rb-asset-cond]"); //radio
        var _assetMake = form.querySelector("select[name=asset-make]");
        var _assetYear = form.querySelector("select[name=asset-year]");
        var _assetModel = form.querySelector("select[name=asset-model]");
        var _purchasePrice = form.querySelector("input[name=pur-price]");
        var _addingExtras = form.querySelector("input[name=rb-extras]");
        var _extras = form.querySelector("select[name=asset-extras]");
        var _extrasAmount = form.querySelector("input[name=extras-amount]");
        var _licenseAndRegExtras = form.querySelector("input[name=license-reg-extras]");
        var _otherExtras = form.querySelector("input[name=other-extras]");
        var _hasDeposit = form.querySelector("input[name=rb-deposit]"); //radio
        var _depositAmount = form.querySelector("input[name=dep-amount]");
        var _totalloanAmount = form.querySelector("input[name=total-loan-amount]");
        var _balloonAmount = form.querySelector("input[name=balloon-amount]");
        var _balloonPercentage = form.querySelector("select[name=balloon-percent]");
        var _interestRateType = form.querySelector("input[name=rb-int-rate]");
        var _repaymentTerm = form.querySelector("select[name=repayment-term]");
        var _surnameOfIndividual = form.querySelector("input[name=pub-official-surname]");
        //const popiaConsent: any = form.querySelector(`input[name=popia-consent]`);		
        var _businessIncome = this.getDataConsentValue(form, "bus-income");
        var _businessExpense = this.getDataConsentValue(form, "bus-expenses");
        var _businessMonthlyIncome;
        var _businessAnnualIncome;
        var _businessMonthlyExpenses;
        var _businessAnnualExpenses;
        if (_businessIncome) {
            if (_businessIncome === "YES") {
                _businessMonthlyIncome = form.querySelector("input[name=business-income]");
                _businessAnnualIncome = "";
            }
            else {
                _businessAnnualIncome = form.querySelector("input[name=business-income]");
                _businessMonthlyIncome = "";
            }
        }
        if (_businessExpense) {
            if (_businessExpense === "YES") {
                _businessMonthlyExpenses = form.querySelector("input[name=business-expenses]");
                _businessAnnualExpenses = "";
            }
            else {
                _businessAnnualExpenses = form.querySelector("input[name=business-expenses]");
                _businessMonthlyExpenses = "";
            }
        }
        if (this.businessType.value === "PRIVATE" || this.businessType.value === "CLOSE" || this.businessType.value === "PUBLIC") {
            this.companyRegistrationOrId = _businessRegNumber ? _businessRegNumber.value : "";
        }
        else {
            this.companyRegistrationOrId = _businessId ? _businessId.value : "";
        }
        // else if (this.businessType.value === `Trust`) {
        // 	this.companyRegistrationOrId = _businessTrustNumber ? _businessTrustNumber.value : "";
        // }
        // else if (this.businessType.value === `OtherContent`) {
        // 	this.companyRegistrationOrId = _businessOtherNumber ? _businessOtherNumber.value : "";
        // }
        var extras = this.selectedExtras.map(function (_) { return _.value; }).join(',');
        var _postData = {
            'email': (_email ? _email.value : ""),
            'recipient': (_recipient ? _recipient.value : ""),
            'subject': (_subject ? _subject.value : ""),
            'firstName': (_firstName ? _firstName.value : ''),
            'surname': (_surname ? _surname.value : ''),
            'idNumber': (_identificationNo ? _identificationNo.value : ''),
            'contactNo': (_phoneNumber ? _phoneNumber.value : ''),
            'emailAddress': (_emailAddress ? _emailAddress.value : ''),
            'relationToCompany': _businessRelation ? _businessRelation.value : "",
            'publicOfficial': (_pubofficial ? _pubofficial.value : ""),
            'relatedToPublicOfficial': (_relpubofficial ? _relpubofficial.value : ""),
            'nameOfIndividual': (_nameOfIndividual ? _nameOfIndividual.value : ""),
            'natureOfRelation': (_natureOfRelation ? _natureOfRelation.value : ""),
            'dataPrivacyConsent': ((_dataPrivacyConsent ? (_dataPrivacyConsent.checked ? "YES" : "NO") : "NO")),
            'businessName': (_businessName ? _businessName.value : ''),
            'entityType': (_entityType ? _entityType.value : ''),
            'businessIndustry': (_businessIndustry ? _businessIndustry.value : ''),
            'natureOfBusiness': (_businessNature ? _businessNature.value : ''),
            'businessDescription': '',
            'region': (_businessRegion ? _businessRegion.value : ''),
            'yearsOperating': (_yearsOperating ? _yearsOperating.value : ''),
            'businessEmailAddress': (_businessEmailAddress ? _businessEmailAddress.value : ''),
            'permissionToActOnBehalf': ((_permissionToActOnBehalf ? (_permissionToActOnBehalf.checked ? "yes" : "no") : "no")),
            'legallyEnterContract': ((_legallyEnterContracts ? (_legallyEnterContracts.checked ? "no" : "yes") : "yes")),
            'covid19Loan': ((_covid19Loan ? (_covid19Loan.checked ? "yes" : "no") : "no")),
            'underDeptReview': ((_debtReview ? (_debtReview.checked ? "yes" : "no") : "no")),
            'registrationNumber': this.companyRegistrationOrId.replace(/\//g, ''),
            'businessIncomeMonthly': (_businessMonthlyIncome ? _businessMonthlyIncome.value : ''),
            'businessIncomeAnnual': (_businessAnnualIncome ? _businessAnnualIncome.value : ''),
            'businessExpensesMonthly': (_businessMonthlyExpenses ? _businessMonthlyExpenses.value : ''),
            'businessExpensesAnnual': (_businessAnnualExpenses ? _businessAnnualExpenses.value : ''),
            'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(form, 'data-sharing-sms'),
            'vehicleCondition': ((_vehicleCondition ? (_vehicleCondition.checked ? "Used" : "New") : "New")),
            'mmCode': (_assetModel ? _assetModel.value : ''),
            'assetMake': (_assetMake ? _assetMake.value : ''),
            'assetYear': (_assetYear ? _assetYear.value : ''),
            'assetModel': _assetModel.options[_assetModel.selectedIndex].text,
            'purchasePrice': (_purchasePrice ? _purchasePrice.value : ''),
            'addingExtras': ((_addingExtras ? (_addingExtras.checked ? "YES" : "NO") : "NO")),
            'extras': ((_addingExtras ? (_addingExtras.checked ? extras : "") : "")),
            'totalAmount': ((_addingExtras ? (_addingExtras.checked ? _extrasAmount.value : "") : "")),
            'licenseAndRegExtras': ((_addingExtras ? (_addingExtras.checked ? _licenseAndRegExtras.value : "") : "")),
            'otherExtras': ((_addingExtras ? (_addingExtras.checked ? _otherExtras.value : "") : "")),
            'hasDeposit': ((_hasDeposit ? (_hasDeposit.checked ? "YES" : "NO") : "NO")),
            'depositAmount': ((_hasDeposit ? (_hasDeposit.checked ? _depositAmount.value : "") : "")),
            'totalLoanAmount': (_totalloanAmount ? _totalloanAmount.value : ''),
            'balloonAmount': (_balloonAmount ? _balloonAmount.value : ''),
            'balloonPercentage': (_balloonPercentage ? _balloonPercentage.value : ''),
            'interestRateType': ((_interestRateType ? (_interestRateType.checked ? "LINKED" : "FIXED") : "FIXED")),
            'repaymentTerm': (_repaymentTerm ? _repaymentTerm.value : ''),
            'surnameOfIndividual': (_surnameOfIndividual ? _surnameOfIndividual.value : '')
        };
        this.formData.append('leadform', new Blob([JSON.stringify(_postData)], {
            type: "application/json"
        }));
        this.createFileFormData();
        this.showDisplayView("loader");
        var url = this.baseUrl + "/bcbsadocumentupload/vaf/save-caf-application";
        // config
        var _config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*'
            }
        };
        // service
        this.formsService.postForm(url, this.formData, _config)
            .then(function (pResponse) {
            if (pResponse.data === "invalid") {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code, false);
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.dtmVirtualPage("step 4 success form");
                if (!_this.iSstep3Completed && !dataLayer.formisSubmitted)
                    _this.analyticsService.dtmFormComplete("complete", pResponse.code, true);
                _this.iSstep3Completed = true;
                _this.analyticsService.completeDtmApplication();
                _this.showDisplayView("success");
            }
        })
            .catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessCafNtb.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessCafNtb.prototype.showDisplayView = function (pDisplay) {
        window.scroll({ top: 50, behavior: "smooth" });
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        this.displayDecline.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            case "decline":
                this.displayDecline.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    FormItemBusinessCafNtb.prototype.dtmVirtualPage = function (pPageNameNew) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:business loans:commercial asset finance:" +
                pPageNameNew;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    FormItemBusinessCafNtb.prototype.updatePageName = function (pageName) {
        dataLayer.pageName =
            "business:products and services:borrow for your needs:business loans:commercial asset finance:" +
                pageName;
    };
    FormItemBusinessCafNtb.prototype.updateFormName = function () {
        var dataNewFormName = "business:products and services:borrow for your needs:business loans:commercial asset finance";
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    FormItemBusinessCafNtb.prototype.toggleModifiersExt = function (event, selector, toggle) {
        var targetModifier = this.element.querySelector(selector);
        var element = event.target;
        if (targetModifier) {
            var formFields = targetModifier.querySelectorAll("input, select");
            if (toggle === "NO") {
                if (element.value === "NO") {
                    targetModifier.classList.remove("form-item-business-caf-ntb__hidden");
                    targetModifier.classList.add("form-item-business-caf-ntb__active");
                    formFields.forEach(function (field) { return field.classList.add("form__input--required"); });
                }
                else {
                    targetModifier.classList.remove("form-item-business-caf-ntb__active");
                    targetModifier.classList.add("form-item-business-caf-ntb__hidden");
                    formFields.forEach(function (field) { return field.classList.remove("form__input--required"); });
                }
            }
            else { //YES
                if (element.value === "YES" || element.value == "THIRDPARTY") {
                    targetModifier.classList.remove("form-item-business-caf-ntb__hidden");
                    targetModifier.classList.add("form-item-business-caf-ntb__active");
                    formFields.forEach(function (field) { return field.classList.add("form__input--required"); });
                }
                else { //NO
                    targetModifier.classList.remove("form-item-business-caf-ntb__active");
                    targetModifier.classList.add("form-item-business-caf-ntb__hidden");
                    formFields.forEach(function (field) { return field.classList.remove("form__input--required"); });
                }
            }
        }
    };
    FormItemBusinessCafNtb.prototype.toggleModifiers = function (event, selector, validation) {
        if (validation === void 0) { validation = true; }
        var targetModifier = this.element.querySelector(selector);
        var formFields = targetModifier.querySelectorAll("input, select, textarea");
        var element = event.target;
        if (targetModifier) {
            if (element.value == "YES") {
                targetModifier.classList.remove("form-item-business-caf-ntb__hidden");
                targetModifier.classList.add("form-item-business-caf-ntb__active");
            }
            else {
                targetModifier.classList.remove("form-item-business-caf-ntb__active");
                targetModifier.classList.add("form-item-business-caf-ntb__hidden");
            }
            if (validation)
                formFields.forEach(function (field) { return field.classList.add("form__input--required"); });
            else
                formFields.forEach(function (field) { return field.classList.remove("form__input--required"); });
        }
    };
    return FormItemBusinessCafNtb;
}(Base));
export { FormItemBusinessCafNtb };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-business-caf-ntb/form-item-business-caf-ntb.component.ts
// module id = 1059
// module chunks = 0